export default {
  props: ['id'],
  data() {
    return {
      loaded: false,
      loadError: false,
      submitting: false,
      currentTest: null,
      step: 0,
      questions: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    course() {
      return this.$store.state.courses.course;
    },
    test() {
      return this.currentTest || { id: this.id, questions: [] };
    },
    try() {
      return this.$store.state.courses.try;
    },
    showTest() {
      return !!(this.try && this.questions.length);
    },
  },
  methods: {
    questionValidate(item) {
      return item.isSingleAnswer ? !!item.answer.checked : item.answer.checked.length > 0;
    },
    async nextStep(questionId, answerIds) {
      if (this.submitting) return;
      this.submitting = true;
      const answer = {
        profile_id: this.user.profile_id,
        try_id: this.try.id,
        question_id: questionId,
        answer_ids: Array.isArray(answerIds) ? answerIds : [answerIds],
      };
      try {
        const response = await this.$store.getters.axl.post('courses/api/test-try/answer', answer);
        this.$store.commit('courses/setTry', response.data.try);
        this.step = response.data.try.step;
      } catch (error) {
        const { response } = error;
        if (response && response.status === 301 && response.data.redirect) {
          this.$router.push(`/results/${this.test.id}`);
        } else if (response && response.status === 400) {
          this.$router.push('/courses');
        } else {
          this.$store.dispatch('HandleError', error);
        }
      } finally {
        this.submitting = false;
      }
    },
    async loadTest() {
      this.loaded = false;
      this.loadError = false;
      this.currentTest = null;
      this.questions = [];
      this.$store.commit('courses/setTry', null);
      try {
        const response = await this.$store.getters.axl.post('courses/api/test/view', { test_id: this.id });
        this.currentTest = response.data.test;
        await this.$store.dispatch('courses/startTry', {
          profile_id: this.user.profile_id,
          test_id: this.id,
        });
        this.step = this.try && this.try.step ? this.try.step : 1;
        this.questions = this.test.questions.map(question => ({
          ...question,
          answer: { id: question.id, checked: question.isSingleAnswer ? 0 : [] },
        }));
      } catch (error) {
        this.loadError = true;
        this.$store.dispatch('HandleError', error);
      } finally {
        this.loaded = true;
      }
    },
  },
  mounted() {
    this.loadTest();
  },
};
